function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTiktokIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "45px",
    height: "50px",
    viewBox: "0 0 45 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(14.509804%,95.686275%,93.333333%)",
      fillOpacity: 1
    },
    d: "M 14.792969 21.660156 L 14.792969 20.128906 C 14.25 20.050781 13.710938 20 13.164062 19.992188 C 7.863281 19.988281 3.175781 23.351562 1.589844 28.320312 C 0 33.28125 1.875 38.679688 6.222656 41.652344 C 2.96875 38.230469 2.0625 33.242188 3.914062 28.925781 C 5.769531 24.609375 10.027344 21.765625 14.792969 21.660156 Z M 14.792969 21.660156 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(14.509804%,95.686275%,93.333333%)",
      fillOpacity: 1
    },
    d: "M 15.085938 38.984375 C 18.046875 38.976562 20.480469 36.6875 20.613281 33.78125 L 20.613281 7.851562 L 25.429688 7.851562 C 25.332031 7.3125 25.285156 6.757812 25.292969 6.210938 L 18.699219 6.210938 L 18.699219 32.117188 C 18.585938 35.03125 16.144531 37.351562 13.171875 37.351562 C 12.285156 37.34375 11.414062 37.128906 10.625 36.726562 C 11.660156 38.136719 13.320312 38.972656 15.085938 38.984375 Z M 34.433594 16.648438 L 34.433594 15.207031 C 32.664062 15.207031 30.925781 14.695312 29.445312 13.730469 C 30.742188 15.207031 32.492188 16.238281 34.433594 16.648438 Z M 34.433594 16.648438 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.607843%,17.254902%,33.333333%)",
      fillOpacity: 1
    },
    d: "M 29.445312 13.730469 C 27.996094 12.101562 27.1875 10.007812 27.195312 7.839844 L 25.429688 7.839844 C 25.890625 10.261719 27.34375 12.390625 29.445312 13.730469 Z M 13.164062 26.472656 C 10.617188 26.484375 8.417969 28.195312 7.8125 30.617188 C 7.207031 33.046875 8.359375 35.558594 10.613281 36.726562 C 9.394531 35.070312 9.21875 32.890625 10.164062 31.074219 C 11.105469 29.257812 13.007812 28.113281 15.085938 28.117188 C 15.636719 28.125 16.191406 28.210938 16.71875 28.367188 L 16.71875 21.777344 C 16.179688 21.691406 15.632812 21.652344 15.085938 21.648438 L 14.792969 21.648438 L 14.792969 26.660156 C 14.265625 26.523438 13.710938 26.457031 13.164062 26.472656 Z M 13.164062 26.472656 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.607843%,17.254902%,33.333333%)",
      fillOpacity: 1
    },
    d: "M 34.433594 16.648438 L 34.433594 21.660156 C 31.152344 21.652344 27.949219 20.632812 25.292969 18.742188 L 25.292969 31.914062 C 25.273438 38.484375 19.851562 43.808594 13.164062 43.808594 C 10.675781 43.808594 8.253906 43.058594 6.222656 41.652344 C 9.609375 45.234375 14.882812 46.414062 19.511719 44.621094 C 24.148438 42.832031 27.1875 38.445312 27.195312 33.554688 L 27.195312 20.421875 C 29.863281 22.296875 33.066406 23.308594 36.347656 23.300781 L 36.347656 16.847656 C 35.703125 16.847656 35.066406 16.777344 34.433594 16.648438 Z M 34.433594 16.648438 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 25.292969 31.914062 L 25.292969 18.742188 C 27.960938 20.625 31.164062 21.632812 34.445312 21.628906 L 34.445312 16.613281 C 32.507812 16.210938 30.753906 15.195312 29.445312 13.730469 C 27.34375 12.390625 25.890625 10.261719 25.429688 7.839844 L 20.613281 7.839844 L 20.613281 33.78125 C 20.515625 36.09375 18.9375 38.097656 16.679688 38.761719 C 14.421875 39.433594 11.980469 38.625 10.597656 36.75 C 8.347656 35.585938 7.195312 33.074219 7.800781 30.644531 C 8.40625 28.222656 10.605469 26.511719 13.152344 26.496094 C 13.703125 26.503906 14.25 26.589844 14.777344 26.75 L 14.777344 21.738281 C 9.988281 21.816406 5.695312 24.675781 3.835938 29.015625 C 1.980469 33.359375 2.910156 38.371094 6.210938 41.789062 C 8.261719 43.152344 10.691406 43.855469 13.164062 43.808594 C 19.851562 43.808594 25.273438 38.484375 25.292969 31.914062 Z M 25.292969 31.914062 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktokIcon);
export default __webpack_public_path__ + "static/media/tiktok-icon.d5db9f923bb3e8650e11237357bb3411.svg";
export { ForwardRef as ReactComponent };